module.exports = __webpack_public_path__ + "static/img/装饰20.ae95fe0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰20.svg
// module id = k/YV
// module chunks = 2